"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSiteService = exports.getSites = void 0;
const api_1 = require("@/services/api");
const ENDPOINT = "/sites";
function getSites() {
    return api_1.axiosInstance
        .get(`${ENDPOINT}`)
        .then((response) => {
        return response.data.rows;
    })
        .catch((error) => {
        throw new Error(`[List sites error]: ${error}`);
    });
}
exports.getSites = getSites;
function createSiteService(siteName, siteLocation) {
    return api_1.axiosInstance
        .post(ENDPOINT, { name: siteName, location: siteLocation })
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Site Error]: ${error}`);
    });
}
exports.createSiteService = createSiteService;
